export default __webpack_public_path__ + "static/media/forestly-noexpl-02_DE.ad9a419a.png";